/* eslint-disable import/no-anonymous-default-export */
import { Action, LANG, SHOW } from "../actions";

const INTIAL_STATE = {
  lang: "ar",
  show: false,
};

export default (state = INTIAL_STATE, action: Action) => {
  switch (action.type) {
    case LANG:
      return {
        ...state,
        lang: action.payload,
      };
    case SHOW:
      return {
        ...state,
        show: action.payload,
      };

    default:
      return state;
  }
};
